const ObjectType = [
  { value: 1, label: "Tổ chức" },
  { value: 2, label: "Cá nhân" },
  { value: 3, label: "Cá nhân thuộc tổ chức" },
];

export default ObjectType;
